<template>
  <div style="width: 100%;height: 400px">
    <l-map ref="map" :zoom="zoom" :options="options">
      <l-tile-layer :url="url"></l-tile-layer>
    </l-map>
  </div>
</template>

<script>
  import Vue from 'vue'

  import L from 'leaflet';

  import {isString} from 'lodash'

  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
  });

  import "leaflet/dist/leaflet.css";

  import {LMap, LTileLayer} from 'vue2-leaflet'

  export default {
    name:"geojson-view",
    //передоваемые параметры
    props: {
      zoom: {
        type: Number,
        default: 13
      },
      url: {
        type: String,
        default: '//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
      },
      options: {
        type: Object,
        default: () => {
          return {}
        }
      },
      value: {
        type: [Object, String],
        default: null
      }
    },
    // локальное состояние
    data() {
      return {
        map: null,
        layers: []
      }
    },

    mounted() {
      this.map = this.$refs.map.mapObject;
    },

    //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
    computed: {},
    //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
    methods: {
      onMapCreated(map) {
        if (this.value) this.setLayerValue(this.value)
      },
      onValueUpdated(value) {
        if (this.value && this.map) this.setLayerValue(this.value);
      },

      setLayerValue(value) {
        const layer = L.geoJSON(isString(value) ? JSON.parse(value) : value, {
          onEachFeature: (feature, layer) => {
            if (feature.properties && feature.properties.popupContent)
              layer.bindPopup(feature.properties.popupContent.map(p => '<p style="margin: 0">' + p + '</\p>').join(''));
          },
          style: () => {
            const color = this.layers.length ? 'yellow' : '#21a3f3';
            return {
              fillColor: color,
              weight: 2,
              opacity: 1,
              color: color,
              fillOpacity: 0.3
            };
          }
        }).addTo(this.map);

        this.layers.push(layer);

        this.map.fitBounds(layer.getBounds())
      }
    },

    components: {
      LMap, LTileLayer
    },

    watch: {
      map(newVal) {
        if (newVal) this.onMapCreated(newVal);
      },
      value(newVal) {
        this.onValueUpdated(newVal);
      }
    }
  }
</script>

<style scoped>

</style>
